import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const EdgeStack = React.lazy(async () => ({
    default: (await import('@oc/edge-stack/module')).EdgeStackModule
}))

export function EdgeStackComponent() {
    return <SuspenseWhileLoading LazyComponent={EdgeStack} />
}
